import { render, staticRenderFns } from "./PermissionInformation.vue?vue&type=template&id=e2dc7d44&scoped=true"
import script from "./PermissionInformation.vue?vue&type=script&lang=js"
export * from "./PermissionInformation.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PermissionInformation.vue?vue&type=style&index=1&id=e2dc7d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dc7d44",
  null
  
)

export default component.exports